import { render, staticRenderFns } from "./DebtVendor.vue?vue&type=template&id=2cbc81d2&scoped=true&"
import script from "./DebtVendor.vue?vue&type=script&lang=js&"
export * from "./DebtVendor.vue?vue&type=script&lang=js&"
import style0 from "./DebtVendor.vue?vue&type=style&index=0&id=2cbc81d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc81d2",
  null
  
)

export default component.exports